module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Medium.e60a3aa.ttf";